// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-IntegrationsDisplay-styles___dialogBox--lLHRC .components-CompanyDetails-IntegrationsDisplay-styles___typeSelect--CUVL2 {
    padding: 22px;
    float: left;
  }
  .components-CompanyDetails-IntegrationsDisplay-styles___dialogBox--lLHRC .components-CompanyDetails-IntegrationsDisplay-styles___closeIcon--p6GUz {
    top: 22px;
    right: 21px;
    position: absolute;
    width: -moz-fit-content !important;
    width: fit-content !important;
  }
  .components-CompanyDetails-IntegrationsDisplay-styles___dialogBox--lLHRC .components-CompanyDetails-IntegrationsDisplay-styles___closeIcon--p6GUz .components-CompanyDetails-IntegrationsDisplay-styles___svg--uyzJW {
      font-size: 26px;
    }
  .components-CompanyDetails-IntegrationsDisplay-styles___dialogBox--lLHRC .components-CompanyDetails-IntegrationsDisplay-styles___title--czcJu {
    font-size: 29px;
    color: #1b2432;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 auto;
    padding: 32px 32px 0;
  }
  .components-CompanyDetails-IntegrationsDisplay-styles___dialogBox--lLHRC .components-CompanyDetails-IntegrationsDisplay-styles___dialogInput--CZnMJ {
    display: flex;
    justify-content: space-evenly;
  }
  .components-CompanyDetails-IntegrationsDisplay-styles___dialogBox--lLHRC a {
    color: #318afb;
    text-decoration: underline;
  }

.components-CompanyDetails-IntegrationsDisplay-styles___infoLoader--x8Jms {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
}

.components-CompanyDetails-IntegrationsDisplay-styles___editDialogContent--RKns0 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 8px !important;
}

.components-CompanyDetails-IntegrationsDisplay-styles___editFormControlLabel--HzVBU {
  display: flex !important;
  justify-content: space-between;
  width: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.components-CompanyDetails-IntegrationsDisplay-styles___cardContainer--zrq8P {
  margin-bottom: 30px;
  display: flex;
  flex-flow: column;
  align-items: center;
  max-width: 736px;
}

.components-CompanyDetails-IntegrationsDisplay-styles___cardContainer--zrq8P .components-CompanyDetails-IntegrationsDisplay-styles___addButton--e911M {
    margin: 10px auto;
  }

.components-CompanyDetails-IntegrationsDisplay-styles___cardContainer--zrq8P .components-CompanyDetails-IntegrationsDisplay-styles___emptyTable--yKunM {
    margin: 10px;
    text-align: center;
    width: 100%;
  }
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/IntegrationsDisplay/styles.pcss"],"names":[],"mappings":"AACE;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,kCAA6B;IAA7B,6BAA6B;EAK/B;EAHE;MACE,eAAe;IACjB;EAEF;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,6BAA6B;EAC/B;EACA;IACE,cAAc;IACd,0BAA0B;EAC5B;;AAGF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AASlB;;AARE;IACE,iBAAiB;EACnB;;AACA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;EACb","sourcesContent":[".dialogBox {\n  .typeSelect {\n    padding: 22px;\n    float: left;\n  }\n  .closeIcon {\n    top: 22px;\n    right: 21px;\n    position: absolute;\n    width: fit-content !important;\n\n    .svg {\n      font-size: 26px;\n    }\n  }\n  .title {\n    font-size: 29px;\n    color: #1b2432;\n    background-color: #fff;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex: 1 0 auto;\n    padding: 32px 32px 0;\n  }\n  .dialogInput {\n    display: flex;\n    justify-content: space-evenly;\n  }\n  a {\n    color: #318afb;\n    text-decoration: underline;\n  }\n}\n\n.infoLoader {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  top: 0;\n  right: 0;\n}\n\n.editDialogContent {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding-top: 8px !important;\n}\n\n.editFormControlLabel {\n  display: flex !important;\n  justify-content: space-between;\n  width: 100%;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.cardContainer {\n  margin-bottom: 30px;\n  display: flex;\n  flex-flow: column;\n  align-items: center;\n  max-width: 736px;\n  .addButton {\n    margin: 10px auto;\n  }\n  .emptyTable {\n    margin: 10px;\n    text-align: center;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogBox": `components-CompanyDetails-IntegrationsDisplay-styles___dialogBox--lLHRC`,
	"typeSelect": `components-CompanyDetails-IntegrationsDisplay-styles___typeSelect--CUVL2`,
	"closeIcon": `components-CompanyDetails-IntegrationsDisplay-styles___closeIcon--p6GUz`,
	"svg": `components-CompanyDetails-IntegrationsDisplay-styles___svg--uyzJW`,
	"title": `components-CompanyDetails-IntegrationsDisplay-styles___title--czcJu`,
	"dialogInput": `components-CompanyDetails-IntegrationsDisplay-styles___dialogInput--CZnMJ`,
	"infoLoader": `components-CompanyDetails-IntegrationsDisplay-styles___infoLoader--x8Jms`,
	"editDialogContent": `components-CompanyDetails-IntegrationsDisplay-styles___editDialogContent--RKns0`,
	"editFormControlLabel": `components-CompanyDetails-IntegrationsDisplay-styles___editFormControlLabel--HzVBU`,
	"cardContainer": `components-CompanyDetails-IntegrationsDisplay-styles___cardContainer--zrq8P`,
	"addButton": `components-CompanyDetails-IntegrationsDisplay-styles___addButton--e911M`,
	"emptyTable": `components-CompanyDetails-IntegrationsDisplay-styles___emptyTable--yKunM`
};
module.exports = ___CSS_LOADER_EXPORT___;
